import { createAction } from 'redux-actions';
import * as types from './alert-constants';

export const snoozeRequest = createAction(types.ALERT_SNOOZE_REQUEST);
export const snoozeSuccess = createAction(types.ALERT_SNOOZE_SUCCESS);
export const snoozeFailure = createAction(types.ALERT_SNOOZE_FAILURE);

export const discardRequest = createAction(types.ALERT_DISCARD_REQUEST);
export const discardSuccess = createAction(types.ALERT_DISCARD_SUCCESS);
export const discardFailure = createAction(types.ALERT_DISCARD_FAILURE);
